import * as types from 'legacy-src/constants/types';

export default function setUserSubjects({ subjects }) {
  return (dispatch) => {
    dispatch({
      type: types.USER_SUBJECTS,
      userSubjects: subjects,
    });
  };
}
